import { CanAccess } from '@modules/common/components/CanAccess';
import { useMuiModalContext } from '@modules/common/components/Modal/ModalContext';
import { DisableIntegrationConfirmationModal } from '@modules/integrationsV2/components/DisableIntegrationConfirmationModal';
import { trackIntegrationPageEvent } from '@modules/integrationsV2/utils';
import { RemoveCircleOutlineRounded } from '@mui/icons-material';
import { ListItemIcon, ListItemText, MenuItem } from '@mui/material';
import {
  IntegrationChannelType,
  IntegrationType,
  PermissionOperation,
  PermissionResource,
} from 'generated/graphql';
import { UUID } from 'v2/core/entities/uuid';

interface DisableIntegrationActionProps {
  channelType: IntegrationChannelType;
  integrationID: UUID;
  integrationType: IntegrationType;
  namespace: string | undefined;
}

export const DisableIntegrationAction = ({
  channelType,
  integrationID,
  integrationType,
  namespace,
}: DisableIntegrationActionProps) => {
  const { openModal } = useMuiModalContext();

  const onClick = () => {
    openModal({
      contentComponent: () => (
        <DisableIntegrationConfirmationModal
          channelType={channelType}
          integrationID={integrationID}
        />
      ),
      modalProps: {
        PaperProps: {
          elevation: 3,
        },
        fullWidth: true,
        maxWidth: 'sm',
      },
    });
    trackIntegrationPageEvent({
      eventName: 'Integrations - Disable Integration Option Clicked',
      integration: {
        channelType,
        integrationType,
        namespace,
      },
    });
  };

  return (
    <CanAccess
      resource={PermissionResource.Integration}
      operation={PermissionOperation.Write}
    >
      <MenuItem onClick={onClick}>
        <ListItemIcon>
          <RemoveCircleOutlineRounded fontSize="small" />
        </ListItemIcon>
        <ListItemText>Disable Integration</ListItemText>
      </MenuItem>
    </CanAccess>
  );
};
